import type { ChartDataItem } from '../types';

// ECharts auto-scales a zero-only series to fractional values. Currency formatters round those
// ticks to repeated "$0" labels, so callers need a stable, non-zero axis interval instead.
export const hasOnlyZeroValues = (data: ChartDataItem[], fields: string[]): boolean => {
  let hasNumericValue = false;

  for (const row of data) {
    for (const field of fields) {
      const value = row[field];
      if (typeof value !== 'number') continue;

      hasNumericValue = true;
      if (value !== 0) return false;
    }
  }

  return hasNumericValue;
};
